<template>
  <div class="senderid">
    <div class="subheading grey--text ma-6 mb-0"><h5>Request SenderId</h5></div>
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6">
          <v-card max-width="600" class="pa-6 custom-card" flat>
            <h3>Request SenderId</h3>
            <SenderIdForm />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SenderIdForm from "@/components/senderid/RequestSenderId";
export default {
  components: { SenderIdForm },
};
</script>
